import { api } from "../../../infra/api";
import { Paginate } from "../../../infra/paginate";
import { URLS } from "../../../infra/URLS";
import { Usuarios } from "../types/UsuariosTipo";

export async function getUser(userId: any) {
  const { data } = await api.get(`${URLS.USER_API}/${userId}`);

  return data;
}

export default async function getUsers(search: string, page = 1) {
  const { data } = await api.get<Paginate<Usuarios>>(
    `${URLS.USER_API}`, {
      params: {page, search}
    });

  return data;
}

export async function getAllUsers() {
  const size = await api
    .get(`${URLS.USER_API}`)
    .then((resp) => resp.data.meta);

  const resultJson = await api.get(
    `${URLS.USER_API}?limit=${size.totalItems}`)
    .then((resp) => resp?.data?.items);

  return resultJson;
}
